export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '',
    slogan:'径山脚下有片田 一年四季产鲜果',
    copyright:'2019-2020 梅唐四季',

    mode:1,     //全局mode：1梅唐四季，2耘径联盟
    // mode:2,     //全局mode：1梅唐四季，2耘径联盟
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        // dev: 'http://127.0.0.1:5500/index.php/',         //本地服务
        dev: 'http://maytown.hhland.com/api/index.php/',    //设置过本地调试跨域的通用服务端
        pro: 'https://mth5.hhland.com/api/index.php/'       //梅唐四季服务端
        // pro: 'https://yunjing.hhland.com/api/index.php/'    //耘径联盟服务端
        // pro: 'https://cm-rain1.1wbu.com/api/index.php/'       //云农场-草莓雨游戏
    },
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: false,
    /**
     * @description 默认打开的首页的路由name值，默认为登录页
     */
    homeName: 'login',
    /**
     * @description 需要加载的插件
     */
    plugin: {
        'error-store': {
            showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
            developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
        }
    },
    weixin:{
        redirect_dev:'https://maytown.hhland.com/api/index.php/api_weixin/weixin_auth_response',
        appid_yj:'wxcca59a8dbfa1975f',
        appid_mt:'wx4622da3b80e75357',
    },
}
